var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell"},[_c('div',{staticClass:"content d-flex align-center",class:_vm.alignClass},[_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }